import store from "../store"
import Emitter from "./Emitter"
import { qs, qsa, bounds } from "../utils"
import Scrollbar from "./Scrollbar"

export default class Smooth {
  constructor(obj) {
    this.scroll = obj.scroll
    this.el = qs("[data-taxi-view]")
    this.elems = null
    this.current = 0
    this.threshold = 100
    this.sections = null
    this.scrollbar = null
    this.init()
  }

  getSections() {
    const { isSmooth } = store.flags

    if (!this.elems || !isSmooth) return

    this.sections = null
    this.sections = []

    this.elems.forEach(el => {
      el.style.transform = "translate3d(0, 0, 0)"
      const speed = el.dataset.speed || 1
      const { top, bottom, offset } = this.getVars(el, speed)
      let parent = el.parentNode.closest(".data-smooth")

      parent &&
        this.sections.some(obj => {
          if (obj.el === parent) parent = obj
        })
      this.sections.push({
        el,
        parent,
        top,
        bottom,
        offset,
        speed,
        out: true,
        transform: 0,
      })
    })
  }

  run = ({ current }) => {
    this.current = current
    this.transformSections()
  }

  transformSections() {
    const { isSmooth, isResizing } = store.flags

    if (!this.sections || !isSmooth) return

    for (let i = 0; i < this.sections.length; i++) {
      const section = this.sections[i]
      const { isVisible, transform } = this.isVisible(section)
      if (isVisible || isResizing) {
        section.out = false
        section.transform = transform
        section.el.style.transform = this.getTransform(transform)
      } else if (!section.out) {
        section.out = true

        section.transform = transform
        section.el.style.transform = this.getTransform(transform)
      }
    }
  }

  isVisible(section) {
    const { vh } = store.page
    const { top, bottom, offset, speed, parent } = section

    const extra = (parent && parent.transform) || 0
    const translate = this.current * speed
    const transform = translate - offset - extra
    const start = top - translate
    const end = bottom - translate
    const isVisible = start < this.threshold + vh && end > -this.threshold

    return {
      isVisible,
      transform,
    }
  }

  getTransform(transform) {
    const _transform = Math.round(transform)
    // const _transform = transform
    return `translate3d(0, ${-_transform}px, 0)`
  }

  getVars(el, speed) {
    const { vh } = store.page
    const rect = bounds(el)
    const centering = vh / 2 - rect.height / 2
    const offset = rect.top < vh ? 0 : (rect.top - centering) * speed - (rect.top - centering)
    const top = rect.top + offset
    const bottom = rect.bottom + offset

    return {
      top,
      bottom,
      offset,
    }
  }

  on() {
    Emitter.on("tick", this.run)
    Emitter.on("resize", this.resize)
  }

  off() {
    Emitter.off("tick", this.run)
    Emitter.off("resize", this.resize)
  }

  update(elems) {
    store.flags.isResizing = true

    this.scroll.setScrollBounds()
    this.elems = elems || qsa(".data-smooth")
    // this.elems = elems || qsa(".shopify-section")
    this.scrollbar.update()
    this.getSections()
    this.transformSections()

    store.flags.isResizing = false
  }

  clean() {
    this.elems = this.sections = null
  }

  resize = () => {
    if (!this.sections) return
    this.sections.forEach(section => {
      section.el.style.transform = "translate3d(0, 0, 0)"
      const { top, bottom, offset } = this.getVars(section.el, section.speed)
      Object.assign(section, {
        top,
        bottom,
        offset,
      })
    })

    Emitter.emit("smooth:resize")
    this.transformSections()
  }

  init(elems) {
    this.elems = elems || qsa(".data-smooth")
    this.getSections()
    this.scrollbar = new Scrollbar()
    this.on()
    this.update()
  }
}
